export default "__VITE_ASSET__KtnMLAg___"